import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Tips.css';
import { trackAnalyticsFeature } from '../../Telemetry/Mixpanel/Features/analyticsTracker';
import { TIP_CLICKED, VALUE_ADD } from '../../Telemetry/Mixpanel/Constants/mixpanelConstants';

class Tips extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  static propTypes = {
    contents: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string
      })
    ).isRequired,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired
    })
  };

  render() {
    return <div className="customTipsCards">{this.displayTipsCards(this.props.contents)}</div>;
  }

  displayTipsCards = contents => {
    const { t } = this.context;

    return contents.map(key => (
      <div className="tipsCardDisplay" key={key.url}>
        <div className="tipsIcon">
          <div className="lightBulbIcon" />
        </div>
        <div className="tipsLink">
          {t('tips.tip')}
          <a
            href={key.url}
            target="_blank"
            onClick={() => trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, TIP_CLICKED)}>
            {key.title}
          </a>
        </div>
      </div>
    ));
  };
}

export default Tips;



// WEBPACK FOOTER //
// ./src/Components/Tips/Tips.js